$('.eiglishFont').css({'cssText': 'font-size: 17px !important;line-height:62px!important;'})
module.exports = { 
  //头部尾部 公共
  menu : { 
    mobile:"手机端",
    login:"登 录",
    register:"注 册",
    zh:"简体中文",
    english:"English",
    home:"首页",
    weather:'天气',
    intoPark:'走进园区',
    inPark:'企业入园',
    hotPark: '新闻资讯',
    serverPark: '交易平台',
    homeePark: '园区服务',
    garden: '园区党建',
    center1: '企业中心',
    center2: '个人中心',
    center3: '退出登录',
    link:'友情链接',
    link2: '市北区人力资源和社会保障局',
    link3:'市北政务网',
    serviceTel: '客服电话',
    feedback: '反馈意见',
    time: '工作时间：9:00-18:00（周一至周五）',
    address: '地址：青岛市北区台柳路179号和达中心B座',
    server: '服务预约',
    dock2: '供需对接',
    recruit2: '企业招聘',
    help: '园区咨询',
    campus: '园区贴吧',
    submit:'提 交',
    replayT: '详情',
    userinfo3: '没有账号？快去注册',
    userinfo4: '确认密码',
    userinfo5: '验证码',
    userinfo6: '真实姓名',
    userinfo7: '身份证号',
    userinfo8: '邮箱',
    userinfo9: '手机号',
    id: '已有账号？快去登录',
    agree: '我已阅读并接受',
    agree2: '用户协议',
    forgetpwd: '忘记密码',
    careful:'注: 请将营业执照复印件送至产业园办公室',
  }, 
  //首页和搜索页
  index:{ 
    onlineOffice:'网上办事大厅',
    quickEntry:'快捷入口',
    VR: 'VR园区',
    watch : '点此观看',
    info :'新闻资讯',
    serverPark: '园区服务',
    serach: '搜索',
    recruit: '招聘信息',
    dock: '对接信息',
    settled : '入驻企业',
    weather:'天气预报',
    happy: '快乐泊寓',
    bus : '公交信息',
    flight: '航班信息',
    train :'列车信息',
    comment: '大众点评',
    baidu : '百度地图',
    surround: '周边生活',
    scan: '官方公众号',
    suggest:'意见箱',
    qust:'调查问卷',
    qust2:'调查问卷列表',
    null1:'暂无招聘信息',
    null2:'暂无对接信息',
    null3:'暂无入驻企业',
    null4:'暂无搜索结果',
  },
  //走进园区
  park:{
    abstract: '园区简介',
    law: '政策法规',
    down: '下载专区',
    down2: '下载',
    null:'暂无数据',
    source:'来源',
    date:'日期',
    null2:'暂无详情',
  },
  //入驻园区
  enterPark:{
    support: '扶持政策',
    conditions :'入驻条件',
    assort: '服务体系',
    application: '入驻申请',
    company: '园区企业',
    companyInfo : "企业基本信息" ,
    companyName: '企业名称',
    companyRegistered : '企业注册地',
    representative : '法定代表人' , 
    linkman: '联系人',  
    linkduty: '联系人职务',  
    linkTel: '联系人电话', 
    linkEmail: '联系人邮箱',   
    direction1: '本企业主营业务方向',
    direction2: '企业经营状况',
    direction3 : '本企业营业额(万)',
    direction4: '营收',
    direction5: '税收',
    direction6: '入园公司注册名称（全称)',
    direction7: '注册资本',
    direction8: '企业主营业务及规模（主营业务、擅长/创新方向、经营业绩、行业地位,200字以上',
    direction9: '园区公司预期主营及规模',
    direction10: '园区公司预期组织架构和人员规模',
    direction11: '公司资源和特色',
    direction12: '现有客户情况（如无请注明原因）',
    direction13: '本市客户或本市潜在客户资源情况',
    direction14: '业务合规性描述',
    direction15: '是否方便实地考察',
    direction16: '入驻申请事项',
    direction17: '申请场地面积（建筑面积 平方米）',
    direction18: '关于入驻申请的其他意见',
    business: '业态',
    floor: '楼层',
  },
  //园区热点
  hotspot:{
    hotPark2: '新闻资讯',
    hotPark3: '通知公告',
    hotPark4: '活动预告',
    hotPark5: '行业资讯',
    hotPark6:'详情',
  },
  //园区服务
  service:{
    serverPark2: '青岛市人力资源交流协会',
    serverPark3: '科研机构',
    serverPark4: '产业基金',
    serverPark5: '产品发布',
    serverPark6: '创新申报',
    serverPark7: '行业协会',
    
  },
  //园区党建
  build:{
    garden2: '组织概况',
    garden3: '党建风采',
    garden4: '初心学舍',
    garden5: '党建活动',
  },
  //智慧E家
  wisdom:{
    learn: '在线学习',
    bookInfo1: '请填写预约申请信息',
    bookInfo2: '申请单位',
    bookInfo3: '申请人',
    bookInfo4: '申请人电话',
    bookInfo5: '申请会议室',
    bookInfo6: '与会人数',
    bookInfo7: '使用时间',
    bookInfo8: '至',
    bookInfo9: '开放梯控时间(早上,中午最多开放2小时)',
    bookInfo10: '会议内容',
    bookInfo11: '其他',
    bookInfo12:  '我已阅读并接受用户协议',
    bookInfo13: '1. 使用单位应在预约时间开始前半小时，到园区办公室申请开启会议室，离开后需将桌椅恢复原位。会后由园区工作人员验收确认无误后方可离开.',
    bookInfo14: '2. 保持室内清洁卫生，会议结束后请将瓶子、纸屑、垃圾等打扫干净，如两次卫生检查不合格单位，将不再受理该单位的会议室使用申请',
    bookInfo15: '3. 会后请及时关闭各电器设备、空调等，如使用期间造成设备故障要及时修复，如有损坏需照价赔偿，均以不影响后续单位使用为原则。否则，将从入驻押金里按照原价扣除，并不再受理该单位的会议室使用申请。',
    bookInfo16: '4. 会议室仅限园区入驻企业内部使用，入驻企业不得以任何借口转借给其他外部企业使用，一经发现，园区管委会办公室有权不再受理该单位的会议室使用申请。',
    bookInfo17: '预约单位',
    bookInfo18: '预约人姓名',
    bookInfo19: '预约人电话',
    bookInfo20: '预约时间',
    bookInfo21: '预约人数',
    express1: '顺丰快递',
    express2: '京东物流',
    express3: '中通快递',
    express4: '申通快递',
    express5: '圆通快递',
    express6: '韵达快递',
    express7: '大众点评',
    express8: '美团外卖',
    express9: '饿了吗',
    release: '发布',
    roomdetail: '会议室详情',
    bookL:'立即预约',


    
    enterprise1: '企业类型',
    enterprise2: '企业行业',
    enterprise3: '企业规模',
    enterprise4: '联系人姓名',
    enterprise5: '业务需求标题',
    enterprise6: '具体业务需求',
    enterprise7: '预计采购时间',
    enterprise8: '预计预算(单位:万)',
    enterprise9: '是否指定供应商',
    enterprise10 : '否',
    enterprise11 : '是',
    enterprise12 : '企业服务类别',
    enterprise13 : '产品名称',
    enterprise14 : '产品介绍',
    position1 : '招聘职位',
    position2 : '薪资福利',
    position3 : '学历',
    position4 : '工作经验',
    position5 : '职位描述',
    position6 : '招聘要求',
    recdetails: '招聘详情',
    allQuet:"全部回答",
    allNote:"全部留言",
    up : '置顶',
    ask : '提问',
    question : '问题',
    Qdetails : '问答详情',
    title:'标题',
    content : '内容',
    dockDetail : '对接详情',
    upload : '上传附件',
    download : '下载附件',
    loginafter : '后回复对接信息',
    reply : '回复',
    replay2 : '后回复',
  },
  //企业中心
  center1:{
    corporateC1: '企业信息',
    corporateC2: '企业产品',
    corporateC3: '企业荣誉',
    corporateC4: '业务需求',
    corporateC5: '业务供给',
    corporateC7: '消息中心',
    corporateC8: '企业相关数据',
    corporateC9: '修改密码',
    corporateC10: '完善企业信息',
    corporateC11: '企业官网',
    corporateC12: '企业性质',
    corporateC13: '行业领域',
    corporateC14: '企业详细介绍',
    corporateC15: '上传图片',
    corporateC16: '保 存',
    fillin: '填写产品信息',
    add: '添加产品',
    add2: '添加荣誉',
    fillin2: '填写荣誉信息',
    honur: '荣誉称号',
    needDetail: '需求详情',
    supplyDetail: '供给详情',
    no: '暂无投递者',
    no2:'暂无对接详情',
    need:'需求公司',
    need2:'供给公司',
    delivery:'投递者信息',
    room:'会议室设备设施',
    book:'会议室预约',
    book2:'合作咨询预约',
    book3:'健身课预告',
    various1: '税收数据（单位:万）',
    various2:'当月引进的高层人才数量',
    unit:'营收数据（单位:万）',
    honour1:'获得荣誉或专利',
    honour2:'青岛公司业绩概况'
  },
  //个人中心
  center2:{
    vitae: '个人简历',
    vertdetails: '简历详情',
    resume1:'姓名',
    resume2:'性别',
    resume3:'年龄',
    resume4:'出生日期',
    resume5:'籍贯',
    resume6:'联系电话',
    resume7:'邮箱',
    resume8:'求职意向',
    resume9:'期待薪资',
    resume10:'教育背景',
    resume11:'实习经历',
    resume12:'所获荣誉',
    resume13:'资格证书',
    resume14:'专业技能',
    resume15:'自我评价',
    resume16:'是否公开简历',
    resume17:'确认修改',
  }
 }


// WEBPACK FOOTER //
// ./src/assets/lang/zh.js